import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  NotificationResp: {},
  isDataFeching: false,
};

export const messageAndNotificationSlice = createSlice({
  name: 'messageAndNotification',
  initialState: INITIAL_STATE,
  reducers: {
    setNotificationResp: (state, action) => {
      state.NotificationResp = action.payload;
    },
    setIsDataFeching: (state, action) => {
      state.isDataFeching = action.payload;
    },

    resetNotificationResp: (state) => {
      state.NotificationResp = INITIAL_STATE.NotificationResp;
      state.isDataFeching = INITIAL_STATE.isDataFeching;
    },
  },
});

export const { setNotificationResp, setIsDataFeching, resetNotificationResp } =
  messageAndNotificationSlice.actions;

export default messageAndNotificationSlice.reducer;
